export const languages: string[] = ['sk', 'de', 'en']

export const defaultLanguage = 'en'
